const styles = theme => ({
  hashtagsArea: {
    marginLeft: theme.spacing(2)
  },
  hashtagContainer: {
    paddingLeft: theme.spacing(2),
    color: theme.palette.primary.default
  },
  addButton: {
    width: 36,
    height: 36
  },
  add: {
    width: 30,
    height: 30,
    color: theme.palette.primary.light
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/SideBox/components/PostSettings/styles.js